import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertDialog } from '../../../components/alertDialog/alertDialog';

interface AppointmentPricingModalProps {
  onDismiss: () => void;
  onConfirm: () => void;
  setShowPricingModal: (open: boolean) => void;
  showPricingModal: boolean;
}
export function AppointmentPricingModal({
  onDismiss,
  onConfirm,
  showPricingModal,
  setShowPricingModal,
}: AppointmentPricingModalProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog
      actions
      title={t('BOOK_TELEHEALTH_APPOINTMENT')}
      open={showPricingModal}
      onConfirm={onConfirm}
      onDismiss={onDismiss}
      setOpen={setShowPricingModal}
      content={t('TELEHEALTH_APPOINTMENT_COST_DETAILS')}
      confirmLabel={t('CONFIRM')}
      cancelLabel={t('CANCEL')}
    />
  );
}
